import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PrivacyPolicyLink from '../../shared/components/PrivacyPolicyLink';
import AppBarRegister from '../../shared/components/AppBarRegister';
import { Button } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import AppBarPortal from '../../shared/components/AppBarPortal';
import { Link } from 'react-router-dom';
import AppLeftPortal from '../../shared/components/AppLeftPortal';
import AppFooterPortal from '../../shared/components/AppFooterPortal';

function TabContainer({ children, dir, padding }) {
  if (typeof padding === 'undefined') {
    padding = 10;
  }
  return (
    <Typography component="div" dir={dir} style={{ padding: padding, flexGrow: 1 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    //width: '100%',
    height: 'calc(100vh - 75px)',
    maxWidth: 760,
    margin: '0 auto'
  },
  appBar: {
    backgroundColor: 'initial',
    boxShadow: 'none',
    borderBottom: '1px solid #f5f5f5'
  },
  mb: {
    marginBottom: 30
  },
  heading: {
    fontWeight: 500, 
    color: 'rgb(66,74,79)'
  },
  paragraph: {
    fontSize: '0.92rem'
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: 'none',
    backgroundImage: 'linear-gradient(to right, rgba(144, 37, 252, 1) , rgba(19, 8, 254,1));'
  },
  buttonIndigo: theme.custom.button.indigo,
  buttonLightDark: theme.custom.button.lightDark,
  privacyPolicy: {
    padding: 15, 
    [theme.breakpoints.up('md')]: {
      position: 'absolute', 
      bottom: 0, 
      textAlign: "center", 
      width: 760,
    }
  }
});


class WhatIs extends React.Component {

  state = {
    activeTab: 0,
  };

  handleChange = (event, activeTab) => {
    this.setState({ activeTab });
  };

  componentDidMount() {
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <React.Fragment>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
      

      <div className={classes.root}>
        <AppBarRegister hideLogo title="Crea tu cuenta" {...this.props} />

        <div align="center" style={{marginTop: -10}}>
          <Typography variant="caption" paragraph>
          Formulario de alta
          </Typography>
        </div>

        <AppBar position="static" color="default" className={classes.appBar}>
          <Tabs
            value={this.state.activeTab}
            onChange={this.handleChange}
            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
            fullWidth
          >
            <Tab label="Voluntario" />
            <Tab label="Consumidor" />
          </Tabs>
        </AppBar>

        {this.state.activeTab == 0 &&
          <TabContainer padding={25}>

            <Typography variant="subheading" className={classes.heading}>Gratificación</Typography>
            <Typography paragraph className={classes.paragraph}>
              Una forma agradable y fácil de ganar un dinero extra a fin de mes.
            </Typography>

            <Typography variant="subheading" className={classes.heading}>¿En qué consiste?</Typography>
            <Typography paragraph className={classes.paragraph}>
              En probar productos cosméticos de calidad para darnos tu opinión y valorar 
              su aceptabilidad y eficacia.
            </Typography>

            <Typography variant="subheading" className={classes.heading}>¿Dónde?</Typography>
            <Typography paragraph className={classes.paragraph}>
              Deberás venir a nuestras instalaciones ubicadas en pleno centro de Barcelona, al 
              lado de plaza Universidad. C/Diputació 180, 08011.
            </Typography>

            <Typography variant="subheading" className={classes.heading}>Equipo profesional</Typography>
            <Typography paragraph className={classes.paragraph}>
              Estudios realizados con total seguridad gracias a nuestro equipo de experimentados 
              científicos y a nuestros médicos (dermatólogo, oftalmólogo...).
            </Typography>

            <Button variant="contained" className={this.props.classes.buttonIndigo} component={Link} to='/register?type=cv'>
              QUIERO SER VOLUNTARIO
            </Button>

          </TabContainer>
        }

        {this.state.activeTab == 1 &&
          <TabContainer dir={theme.direction} padding={25}>

            <Typography variant="subheading" className={classes.heading}>Productos cosméticos gratuitos</Typography>
            <Typography paragraph className={classes.paragraph}>
              Recibirás en tu domicilio productos cosméticos personalizados y de calidad 
              de forma gratuita.
            </Typography>

            <Typography variant="subheading" className={classes.heading}>¿En qué consiste?</Typography>
            <Typography paragraph className={classes.paragraph}>
              Tu opinión es importante. Prueba los productos cosméticos que recibas sin desplazarte y 
              danos tu valoración bajo cuestionario online, de forma ágil y rápida.
            </Typography>

            <Typography variant="subheading" className={classes.heading}>Productos de calidad</Typography>
            <Typography paragraph className={classes.paragraph}>
              Los productos probados han sido previamente evaluados y aprobados por nuestros 
              expertos, así que pueden utilizarse con total seguridad.
            </Typography>

            <Button variant="contained" className={this.props.classes.buttonIndigo} component={Link} to='/register?type=c'>
              QUIERO SER CONSUMIDOR
            </Button>

          </TabContainer>
        }

        <div align="center" className={classes.privacyPolicy}>
          <PrivacyPolicyLink />
        </div>

      </div>
      </React.Fragment>
    );
  }
}

WhatIs.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(WhatIs);


// WEBPACK FOOTER //
// ./src/modules/register/pages/WhatIs.js